import { render } from "./WrongConferenceIDPopUp.vue?vue&type=template&id=2512a996&scoped=true&ts=true&lang=pug"
import script from "./WrongConferenceIDPopUp.vue?vue&type=script&lang=ts"
export * from "./WrongConferenceIDPopUp.vue?vue&type=script&lang=ts"

import "./WrongConferenceIDPopUp.vue?vue&type=style&index=0&id=2512a996&scoped=true&lang=css"

import exportComponent from "/builds/checkmeru/renova-telemedicine/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2512a996"]])

export default __exports__